import { ArrowUpDown, Binary, Coins, Dices, Spade, Split, Ticket } from "lucide-react";
import type { PopTone } from "../types";

export type ToolId = "heads-or-tails" | "roll-the-dice" | "red-or-black" | "odd-or-even" | "this-or-that" | "raffle-draw" | "higher-or-lower";

export interface ToolMeta {
  id: ToolId;
  name: string;
  tagline: string;
  tone: PopTone;
  icon: any;
  art: string;
  tile: string;
}

export const TOOLS: ToolMeta[] = [
  { id: "heads-or-tails", name: "Heads or Tails", tagline: "The classic. Flip it.", tone: "yellow", icon: Coins, art: "/icons/coin.png", tile: "bg-[#FFE9A8] border-[#FFD36B]" },
  { id: "roll-the-dice", name: "Roll the Dice", tagline: "Up to three dice. Let fate roll.", tone: "pink", icon: Dices, art: "/icons/dice.png", tile: "bg-[#CDEBFF] border-[#9FD3FF]" },
  { id: "red-or-black", name: "Red or Black", tagline: "DITHER draws a card.", tone: "orange", icon: Spade, art: "/icons/cards.png", tile: "bg-[#FFC9C2] border-[#FF9F94]" },
  { id: "odd-or-even", name: "Odd or Even", tagline: "A number from 1 to 100 decides.", tone: "teal", icon: Binary, art: "12", tile: "bg-[#FFD1EC] border-[#FFA8DA]" },
  { id: "this-or-that", name: "This or That", tagline: "Two options. One winner.", tone: "purple", icon: Split, art: "/icons/question.png", tile: "bg-[#E2C9FF] border-[#C9A3FF]" },
  { id: "raffle-draw", name: "Raffle Draw", tagline: "Draw winning tickets for up to 5 prizes.", tone: "green", icon: Ticket, art: "1st", tile: "bg-[#FFF0B3] border-[#FFDF6B]" },
  { id: "higher-or-lower", name: "Higher or Lower", tagline: "Guess the next number. Build a streak.", tone: "yellow", icon: ArrowUpDown, art: "/icons/arrows.png", tile: "bg-[#CFF5CF] border-[#9FE59F]" },
];

export const toolById = (id?: string) => TOOLS.find((t) => t.id === id);
